/* istanbul ignore file */
import React from 'react';
import { TextFieldProps } from '@mui/material';
import { MuiTimePicker } from './mui-time-picker';

import './time-picker.scss';
import { validateDefaultTimeFormat, validateHoursWithoutMinutes, validateHoursMinutesWithoutColon } from './time-validators';

export type TimePickerValue =
  | undefined
  | string
  | {
      hours: number;
      minutes: number;
    };

export interface ITimePickerProps {
  value: TimePickerValue;
  onChange: (timestamp: TimePickerValue) => void;
  name?: string;
  className?: string;
  label: string;
  error?: boolean;
  errorText?: React.ReactNode;
  warningText?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  inlineDisplay?: boolean;
  // Validators are functions that return ether "undefined"=invalid or any value=valid.
  // Validators are executed in the order they are specified until a validator returns a value other than "undefined".
  // If all validators return undefined then the value is considered invalid.
  validators?: Array<(value: string) => TimePickerValue>;
  invalidDateMessage?: string;
  fullWidth?: boolean;
  variant?: TextFieldProps['variant'];
  onInternalValidation?(failiureCause: string | undefined): void;
  minTime?: Date;
  maxTime?: Date;
}

export function TimePicker(props: ITimePickerProps) {
  const {
    value,
    onChange,
    name,
    className,
    label,
    required,
    readOnly,
    error,
    errorText,
    disabled,
    inlineDisplay,
    warningText,
    validators = [validateHoursWithoutMinutes, validateDefaultTimeFormat, validateHoursMinutesWithoutColon],
    invalidDateMessage = 'Indtast et gyldigt tidspunkt',
    variant = 'filled',
    fullWidth,
    onInternalValidation,
    minTime,
    maxTime,
  } = props;

  return (
    <MuiTimePicker
      value={value}
      onChange={onChange}
      name={name}
      className={className}
      label={label}
      error={error}
      errorText={errorText}
      warningText={warningText}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      inlineDisplay={inlineDisplay}
      validators={validators}
      invalidDateMessage={invalidDateMessage}
      fullWidth={fullWidth}
      variant={variant}
      onInternalValidation={onInternalValidation}
      minTime={minTime}
      maxTime={maxTime}
    />
  );
}
